import { render } from "./StartOutletPopover.vue?vue&type=template&id=60b1d5d4&scoped=true"
import script from "./StartOutletPopover.vue?vue&type=script&lang=js"
export * from "./StartOutletPopover.vue?vue&type=script&lang=js"

import "./StartOutletPopover.vue?vue&type=style&index=0&id=60b1d5d4&scoped=true&lang=css"

import exportComponent from "/Users/fredde/programvara/boove.se/w3.boove.se/w3.boove.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60b1d5d4"]])

export default __exports__